// Define a function to generate the AWS Mobile configuration object
function generateAwsMobileConfig({
    identityPoolId,
    userPoolsId,
    userPoolsWebClientId,
    userFilesS3Bucket,
    region = 'us-west-1'
}) {
    const awsmobile = {
        aws_project_region: region,
        aws_cognito_identity_pool_id: identityPoolId,
        aws_cognito_region: region,
        aws_user_pools_id: userPoolsId,
        aws_user_pools_web_client_id: userPoolsWebClientId,
        oauth: {
            domain: process.env.REACT_APP_USER_POOL_DOMAIN,
            scope: [
                "openid",
                "email",
                "profile",
                "aws.cognito.signin.user.admin"
            ],
            redirectSignIn: process.env.REACT_APP_FRONTEND_DOMAIN + '/dashboard',
            redirectSignOut: process.env.REACT_APP_FRONTEND_DOMAIN,
            responseType: "code"
        },
        aws_cognito_username_attributes: ["EMAIL"],
        aws_cognito_social_providers: ["GOOGLE", "APPLE"],
        aws_cognito_signup_attributes: ["EMAIL"],
        aws_cognito_mfa_configuration: "OFF",
        aws_cognito_mfa_types: ["SMS"],
        aws_cognito_password_protection_settings: {
            passwordPolicyMinLength: 8,
            passwordPolicyCharacters: []
        },
        aws_cognito_verification_mechanisms: ["EMAIL"],
        aws_user_files_s3_bucket: userFilesS3Bucket,
        aws_user_files_s3_bucket_region: region
    };
    return awsmobile;
}

// Export the function that generates the configuration
export default generateAwsMobileConfig;

// Example usage to generate the config
export const myAwsMobileConfig = generateAwsMobileConfig({
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    userPoolsId: process.env.REACT_APP_USER_POOL_ID,
    userPoolsWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    userFilesS3Bucket: process.env.REACT_APP_BUCKET_NAME
});

